import { useState } from 'react';
import { useDebounceCallback, useEventListener } from 'usehooks-ts';

export default function useScrollDirection() {
  const [scrollDirection, setScrollDirection] = useState<string | null>(null);
  const [lastScrollTop, setLastScrollTop] = useState(0);

  const debouncedHandleScroll = useDebounceCallback(() => {
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (currentScrollTop > lastScrollTop) {
      // Scroll down
      setScrollDirection('down');
    } else if (currentScrollTop < lastScrollTop) {
      // Scroll up
      setScrollDirection('up');
    }

    setLastScrollTop(currentScrollTop);
  }, 10);

  useEventListener('scroll', debouncedHandleScroll);

  return scrollDirection;
}
